import { HttpClient, HttpHeaders } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { IFirm } from "../../views-interfaces/firml.interface";
import { AppSettingsService } from "../app-settings-service/app-settings.service";
import { ResponseErrorHandlerService } from "../response-error-handler-service/response-error-handler.service";
import { IFirmsResponse } from "./firms-response.interface";

@Injectable()
export class FirmsService {
    private http = inject(HttpClient);
    private appSettingsService = inject(AppSettingsService);
    private firmLoadPromise: Promise<IFirm>;
    private Firm: IFirm;
    private readonly responseErrorHandlerService = inject(ResponseErrorHandlerService);

    constructor() {}

    async loadFirm(id: string) {
        try {
            const result = await firstValueFrom(
                this.http.get<IFirmsResponse>(this.getUrl("firms/" + id), {
                    headers: new HttpHeaders().set("Content-Type", "application/json"),
                }),
            );
            if (result.Code == 200) {
                this.Firm = result.Firm;
            }
            return result.Firm;
        } catch (error) {
            this.responseErrorHandlerService.showPopup({
                typeLayout: "ERROR",
                messageCode: "defaultError",
            });
        }
    }

    async getFirmById(id: string) {
        if (!this.firmLoadPromise) {
            this.firmLoadPromise = this.loadFirm(id);
        }
        return this.firmLoadPromise;
    }

    private getUrl(path = "") {
        return this.appSettingsService.appSettings.FirmsService_URL + this.appSettingsService.appSettings.FirmsService_Version + path;
    }
}
